export const cardContent = {
  root: {
    padding: '1.25rem 1rem',
    '&:last-child': {
      paddingBottom: '1.25rem',
    },
  },
};
